export const FAIRTRANSPORT_MEMBERSHIP_TYPES = {
    MEMBER: 'fair-transport',
    VALUELEVEL1: 'mervardesniva-1',
    VALUELEVEL2: 'mervardesniva-2',
    VALUELEVEL3: 'mervardesniva-3'
} as const;

export type FairtransportMembershipType =
    (typeof FAIRTRANSPORT_MEMBERSHIP_TYPES)[keyof typeof FAIRTRANSPORT_MEMBERSHIP_TYPES] | null;
